<template>
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left"
             label-width="150px"
             class="demo-ruleForm login-container">
        <h3 class="title">Forget Password</h3>
        <el-form-item prop="username" label="UserName">
            <el-input type="text" v-model="ruleForm2.username" auto-complete="off" placeholder="UserName"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="Email">
            <el-input type="text" v-model="ruleForm2.email" auto-complete="off"
                      placeholder="Password"></el-input>
        </el-form-item>
        <el-form-item align="right">
            <a type="primary" style="margin-bottom: 15px;cursor: pointer;color: #409eff;" @click="$router.push('login')">Login</a>
        </el-form-item>
        <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit" :loading="loading">
                Submit
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import {login, validateRegister, register,requestForgetPassword} from '../api/securityService';

    let inviteId = "";
    let validate = false;
    export default {
        data() {
            return {
                validate: validate,
                loading: false,
                ruleForm2: {
                    username: '',
                    email: ''
                },
                rules2: {
                    username: [
                        {required: true, message: 'Please enter username', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: 'Please enter email', trigger: 'blur'}
                    ]
                },
                checked: true
            };
        },
        methods: {
            validatePassword(rule, value, callback) {
                if (this.ruleForm2.password !== this.ruleForm2.rePassword) {
                    callback(new Error('Password not match.'));
                } else {
                    callback();
                }
            },
            submitRegister() {


            },
            handleSubmit(ev) {
                let _this = this;
                this.$refs.ruleForm2.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let params = {
                            userName:this.ruleForm2.username,
                            email:this.ruleForm2.email,
                        };
                        requestForgetPassword(params).then(data=>{
                            this.loading = false;
                            if (data.status === 200) {
                                this.$message.success("Email Send Success.");
                            }else{
                                this.$message.error(data.message);
                            }
                        }).catch(error => {
                            this.loading = false;
                            console.log(error);
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }

</script>

<style lang="scss" scoped>
    .login-container {
        /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        margin: 180px auto;
        width: 600px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;

        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }

        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// forgetPassword.vue?91e2f552